import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { GetStatus } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import LocationAccessModal from "../LocationAccess/LocationAccessModal"
import { useCallApi } from "api/apiHooks"
import { useModal } from "utils/context/ModalContext"
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards"

export default function UserForm(){
    const navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchUserByUserId, fetchDeleteUser, fetchInsertUser, fetchUpdateUser } = useCallApi()

    // Query String
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramUserId = queryString.get("userId")

    const [locationAccessModal, setLocationAccessModal] = useState({ isOpen: false, userId: 0, name: EmptyString })

    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [password, setPassword] = useState(EmptyString)
    const [confirmPassword, setConfirmPassword] = useState(EmptyString)
    const [isAdmin, setIsAdmin] = useState(false)

    const [errorUsername, setErrorUsername] = useState(false)
    const [errorName, setErrorName] = useState(false)
    const [errorPassword, setErrorPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [errorConfirmPasswordMessage, setErrorConfirmPasswordMessage] = useState(EmptyString)

    const usernameChange = (e) => { setUsername(e.target.value) }
    const nameChange = (e) => { setName(e.target.value) }
    const passwordChange = (e) => { setPassword(e.target.value) }
    const confirmPasswordChange = (e) => { setConfirmPassword(e.target.value) }
    const isAdminChange = (e) => { setIsAdmin(!isAdmin) }

    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const saveBtnClick = async () => {
        // Validasi
        if (username === '') {
            showFail("Username is required!")
            return
        }
        if (name === '') {
            showFail("Name is required!")
            return
        }
        if (password === '' || confirmPassword === '') {
            showFail("Password is required!")
            return
        }
        if (password !== confirmPassword) {
            showFail("Password not match!")
            return
        }

        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                if (formType === FormTypeAdd){
                    const res = await fetchInsertUser(
                        username,
                        name,
                        password,
                        isAdmin
                    )
                    if (!res) return
                }else{
                    const res = await fetchUpdateUser(
                        paramUserId,
                        username,
                        name,
                        password,
                        isAdmin
                    )
                    if (!res) return
                }
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: () => {
                        navigate("/setting/user")
                    }
                })
            }
        }
    }
    const deleteBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await fetchDeleteUser(paramUserId, status)
                if (!res) return
            } finally {
                hideLoading()
                showSuccess({
                    onSuccess: () => {
                        navigate("/setting/user")
                    }
                })
            }
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    const accessLocationBtnClick = (name) => {
        setLocationAccessModal({ isOpen: true, userId: paramUserId, name: name })
    }

    function fHandleConfirmPasswordInput(value){
        if (password !== value){
            setErrorConfirmPasswordMessage("Password did not match!")
            setErrorConfirmPassword(true)
        }else{
            setErrorConfirmPassword(false)
        }
    }
    
    useEffect(() => {
        if (formType === FormTypeEdit){
            showLoading()

            fetchUserByUserId(paramUserId).then((res) => {
                if (!res) return

                let data = res.data

                setUsername(data.username)
                setName(data.fullName)
                setIsAdmin(data.isAdmin)
                setStatus(data.status)
                setCreateDate(data.createDate)
                setUpdateDate(data.updateDate)
                setUpdateBy(data.updateBy)
            }).finally(() => {
                hideLoading()
            })
        }
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle 
                title={'User Detail'}
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            <div className="mt-5 flex flex-col gap-3">
                {/* Username */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Username</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={username} onChange={usernameChange} />
                            </div>
                            <div className={`mt-2 sm:mt-0 ${ formType === FormTypeEdit ? 'block' : 'hidden' }`} 
                                onClick={() => accessLocationBtnClick(name) }
                            >
                                <button className="bg-black px-4 py-2 rounded-md hover:bg-gray-800 hover:shadow-md ml-4">
                                    <span className="text-white">Access Location</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorUsername ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Username is required!</span>
                    </div>
                </div>                
                <FormCard title='Name'>
                    <input className="input" value={name} onChange={nameChange} />
                </FormCard>
                <FormCard title='Password'>
                    <input className="input" value={password} onChange={passwordChange} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} type="password" />
                </FormCard>
                <FormCard title='Confirm Password'>
                    <input className="input" value={confirmPassword} onChange={confirmPasswordChange} onInput={(e) => { fHandleConfirmPasswordInput(e.target.value) }} type="password" />
                </FormCard>
                <FormCard title='Admin'>
                    <input type="checkbox" className="" value={isAdmin} onChange={isAdminChange} checked={isAdmin} />
                </FormCard>
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false)} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {locationAccessModal.isOpen && ( 
                <LocationAccessModal 
                    onClose={() => setLocationAccessModal({ isOpen: false, userId: 0 })} 
                    data={locationAccessModal?.data} 
                    userId={locationAccessModal?.userId}
                    name={locationAccessModal?.name}
                />
            )}
        </MainBodyCard>
    )
}